var _style, _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterTableIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,1.9h24v24h-24V1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.6,4.3h24v24h-24V4.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11,18h2c0.6,0,1-0.5,1-1s-0.4-1-1-1h-2c-0.6,0-1,0.5-1,1S10.4,18,11,18z M3,7c0,0.6,0.5,1,1,1h16c0.5,0,1-0.4,1-1 s-0.5-1-1-1H4C3.5,6,3,6.4,3,7z M7,13h10c0.5,0,1-0.4,1-1s-0.5-1-1-1H7c-0.6,0-1,0.4-1,1S6.4,13,7,13z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: -0.4,
    className: "st0",
    width: 24,
    height: 24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTableIcon);
export default __webpack_public_path__ + "static/media/FilterTableIcon.eacdd5a21deff2f9c3b091c6a35703c8.svg";
export { ForwardRef as ReactComponent };